export * from './json-pointer'
export * as default from './json-pointer'
